/* eslint-disable no-console */
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import externalApi from '../../../utils/externalApi';

const ActionType = {
  RECEIVE_GEEKSJOKE: 'RECEIVE_GEEKSJOKE',
};

function receiveGeeksJokeActionCreator(geeksJoke) {
  return {
    type: ActionType.RECEIVE_GEEKSJOKE,
    payload: {
      geeksJoke,
    },
  };
}

function asyncReceiveGeeksJoke() {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const geeksJoke = await externalApi.getGeeksJoke();
      dispatch(receiveGeeksJokeActionCreator(geeksJoke));
    } catch (error) {
      console.log('Failed to load joke');
    }
    dispatch(hideLoading());
  };
}

export { ActionType, receiveGeeksJokeActionCreator, asyncReceiveGeeksJoke };
